<div
  id="device-setting-table-container"
  class="matp-table-container"
  [ngClass]="{
    'tw-max-h-[calc(100vh_-_250px)]': role === 'tenant_admin',
    'tw-max-h-[calc(100vh_-_179px)]': role !== 'tenant_admin',
  }"
>
  <div class="matp-table-actions-area">
    <div class="matp-table-actions">
      <div class="tw-flex tw-mt-1">
        <div class="tw-flex tw-ml-auto">
          <button
            mat-raised-button
            id="filter-clear-btn"
            class="tw-mr-2"
            (click)="clearFilters()"
          >
            <mat-icon>restart_alt</mat-icon>
            <span>クリア</span>
          </button>
          @if (role === "tenant_admin") {
            <button
              mat-raised-button
              id="add-btn"
              color="primary"
              class="tw-mr-2"
              (click)="updatedTag.emit(selection.selected)"
              [disabled]="!selection.hasValue()"
            >
              <span>タグ設定</span>
            </button>
          }

          <button
            mat-icon-button
            id="menu-btn"
            class="!tw-h-10 !tw-w-10 tw-text-[1.8rem] !tw-p-1 tw-mx-2"
            [mat-menu-trigger-for]="menuFilter"
          >
            <mat-icon class="matp-icon-default">filter_list</mat-icon>
          </button>

          <mat-menu #menuFilter="matMenu">
            <ng-container *ngFor="let option of options">
              <ng-container *ngIf="option.name !== 'checkbox'">
                <button mat-menu-item (click)="$event.stopPropagation()">
                  <mat-checkbox
                    [(ngModel)]="option.checked"
                    [disabled]="option.disabled"
                    (change)="updateDisplayList()"
                    color="primary"
                    >{{ option.displayName }}</mat-checkbox
                  >
                </button>
              </ng-container>
            </ng-container>
          </mat-menu>
        </div>
      </div>
    </div>
  </div>

  <div class="matp-table-area">
    <table
      mat-table
      matSort
      [matSortActive]="initSortState.active"
      [matSortDirection]="initSortState.direction"
      [dataSource]="dataSource"
      id="device-setting-table"
      class="matp-table"
    >
      <!-- チェックボックス -->
      <ng-container matColumnDef="checkbox">
        <th mat-header-cell *matHeaderCellDef class="matp-table-header-middle">
          <mat-checkbox
            name="selectAll"
            color="primary"
            (change)="$event ? toggleAllRows() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          ></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox
            name="select"
            color="primary"
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(element) : null"
            [checked]="selection.isSelected(element)"
          ></mat-checkbox>
        </td>
      </ng-container>

      <!-- デバイス名 -->
      <ng-container matColumnDef="deviceName">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">デバイス名</div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              name="deviceName"
              matInput
              appAutocompleteOff
              name="deviceNameFilter"
              type="text"
              [(ngModel)]="deviceNameKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="devicename-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearDeviceNameFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td name="deviceName" mat-cell *matCellDef="let element">
          @if (editingDeviceId === element.serialNo) {
            <div class="device-name-editor">
              <mat-form-field appearance="outline" class="matp-form-field-slim">
                <input #deviceNameInput matInput aria-label="デバイス名"
                  [formControl]="deviceNameControl"
                  [readonly]="savingDeviceName"
                  (keydown.enter)="$event.preventDefault(); saveDeviceName(element)"
                  (keydown.escape)="cancelDeviceNameEdit()" />
                <mat-error>デバイス名は空白以外の文字を含めて入力してください。</mat-error>
              </mat-form-field>
              <button type="button" mat-icon-button aria-label="デバイス名を保存"
                [disabled]="savingDeviceName || deviceNameControl.invalid"
                (click)="saveDeviceName(element)"><mat-icon>check</mat-icon></button>
              <button type="button" mat-icon-button aria-label="デバイス名の編集を取消"
                [disabled]="savingDeviceName"
                (click)="cancelDeviceNameEdit()"><mat-icon>close</mat-icon></button>
            </div>
          } @else {
            <div class="device-name-display">
              <a
                href="javascript:void(0)"
                (click)="updated.emit(element)"
                class="tw-whitespace-nowrap"
                >{{ element.deviceName }}</a
              >
              @if (canEditDeviceName(element)) {
                <button type="button" mat-icon-button aria-label="デバイス名を編集"
                  [disabled]="savingDeviceName" (click)="editDeviceName(element)">
                  <mat-icon>edit</mat-icon>
                </button>
              }
            </div>
          }
        </td>
      </ng-container>

      <!-- シリアル番号 -->
      <ng-container matColumnDef="serialNo">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">
            シリアル番号
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              name="serialNo"
              matInput
              appAutocompleteOff
              name="serialNoFilter"
              type="text"
              [(ngModel)]="serialNoKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="serialno-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearSerialNoFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="serialNo" *matCellDef="let element">
          {{ element.serialNo }}
        </td>
      </ng-container>

      <!-- デバイス種類ID -->
      <ng-container matColumnDef="deviceTypeId">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">
            デバイス種類
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <mat-select
              [(ngModel)]="selectedDeviceType"
              name="deviceTypeFilter"
              panelClass="matp-table-select-panel"
              (selectionChange)="applyFilter()"
            >
              <mat-option [value]="null"></mat-option>
              @for (displayName of deviceTypeDisplayNames; track displayName) {
                <mat-option [value]="displayName">{{ displayName }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </th>
        <td
          mat-cell
          name="deviceTypeId"
          *matCellDef="let element"
          class="tw-w-20"
        >
          {{ element.deviceTypeDisplayName }}
        </td>
      </ng-container>

      <!-- 最終更新日時 -->
      <ng-container matColumnDef="lastCommunicationAt">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">
            最終更新日時
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              name="lastCommunicationAt"
              matInput
              appAutocompleteOff
              name="lastCommunicationAtFilter"
              type="text"
              [(ngModel)]="lastCommunicationAtKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="lastCommunicationat-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearLastCommunicationAtFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="lastCommunicationAt" *matCellDef="let element">
          {{ element.lastCommunicationAt | date: " yyyy/MM/dd HH:mm:ss" }}
        </td>
      </ng-container>

      <!-- ステータス -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">ステータス</div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              name="status"
              matInput
              appAutocompleteOff
              name="statusFilter"
              type="text"
              [(ngModel)]="statusKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="status-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearStatusFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="status" *matCellDef="let element">
          <ng-container *ngIf="element.validContractState; else contractEnded">
            {{ element.status }}
          </ng-container>
          <ng-template #contractEnded>
            <span style="color: red">{{ element.status }}</span>
          </ng-template>
        </td>
      </ng-container>

      <!-- バッテリー -->
      <ng-container matColumnDef="battery">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">バッテリー</div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              name="battery"
              matInput
              appAutocompleteOff
              name="batteryFilter"
              type="text"
              [(ngModel)]="batteryKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="battery-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearBatteryFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="battery" *matCellDef="let element">
          <div class="tw-flex tw-items-center">
            <div class="tw-w-10">
              {{ element.battery | numeral: "0" }}
              <span *ngIf="element.battery">%</span>
            </div>
            @if (element.battery) {
              <div class="tw-h-6 tw-ml-1">
                <app-battery-icon
                  [batteryPercentage]="element.battery"
                ></app-battery-icon>
              </div>
            }
          </div>
        </td>
      </ng-container>

      <!-- 設定グループ -->
      <ng-container matColumnDef="settingGroupName">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">
            設定グループ
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              name="settingGroupName"
              matInput
              appAutocompleteOff
              name="settingGroupFilter"
              type="text"
              [(ngModel)]="settingGroupNameKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="settinggroup-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearSettingGroupNameFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="settingGroupName" *matCellDef="let element">
          {{ element.settingGroupName }}
        </td>
      </ng-container>

      <!-- タグ -->
      <ng-container matColumnDef="tag">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">タグ</div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              name="tag"
              matInput
              appAutocompleteOff
              name="tagFilter"
              type="text"
              [(ngModel)]="tagKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="tag-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearTagFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="tag" *matCellDef="let element">
          <div *ngFor="let tag of element.tagList" class="tw-inline-block">
            <mat-card
              class="tw-m-2 tw-p-1 !tw-inline-block"
              [ngStyle]="tagStyle(tag.color)"
              *ngIf="tag"
              >{{ tag.tagName }}</mat-card
            >
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{ '!tw-bg-gray-300': !row.validContractState }"
      ></tr>
    </table>
  </div>

  <mat-paginator
    id="devicesetting-table-paginator"
    [length]="dataSource.filteredData.length"
    hidePageSize
    showFirstLastButtons
  >
  </mat-paginator>
</div>
